import { type ReactElement } from 'react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@front/model'
import { Page, TButton } from '@components'

function ImportMoved(): ReactElement {
  const { t } = useTranslation()

  return (
    <Page>
      <Page.Content>
        <Page.Hero
          icon='file_save'
          title={t('Import has moved')}
          description={t('Import is now under the Integrations tab.')}
        >
          <TButton component={Link} to='/integration/import'>
            {t('Go to Import')}
          </TButton>
        </Page.Hero>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/import/')({
  component: ImportMoved,
})
